import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.runs');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDate, formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-runs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.runs/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

* {
  box-sizing: border-box;
}

button, input, select {
  font: inherit;
}

.generation-drive {
  position: relative;
  max-width: 1540px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 24px 28px 36px;
  color: #22312c;
}

.drive-shell {
  min-height: 620px;
  display: grid;
  overflow: hidden;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.drive-panel {
  position: relative;
  min-width: 0;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.drive-loading-bar {
  position: absolute;
  z-index: 8;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: #dceae5;
}

.drive-loading-bar i {
  position: absolute;
  width: 34%;
  height: 100%;
  background: #248765;
  animation: drive-loading 1s ease-in-out infinite;
}

@keyframes drive-loading {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(300%);
  }
}
.drive-page-header {
  position: relative;
  z-index: 4;
  border-bottom: 1px solid #e7ecea;
  background: #fff;
}

.drive-navigation-bar {
  min-width: 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  padding: 0 22px;
  border-bottom: 1px solid #edf1ef;
  gap: 22px;
}

.breadcrumbs {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
}

.breadcrumbs > button {
  flex: 0 0 auto;
  border: 0;
  padding: 6px 7px;
  color: #5b7067;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}

.breadcrumbs > button:hover {
  color: #126149;
}

.breadcrumbs > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  fill: none;
  stroke: #9aa7a1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.breadcrumbs h1 {
  max-width: 220px;
  overflow: hidden;
  margin: 0;
  padding: 6px 7px;
  color: #172f27;
  font-size: 14px;
  font-weight: 800;
  line-height: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navigation-tools {
  min-width: 0;
  display: flex;
  flex: 0 1 650px;
  align-items: center;
  justify-content: flex-end;
}

.drive-search {
  min-width: 240px;
  max-width: 540px;
  height: 42px;
  display: flex;
  flex: 1 1 360px;
  align-items: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: #f1f4f3;
  gap: 11px;
}

.drive-search:focus-within {
  border-color: #c9d7d2;
  background: #fff;
  box-shadow: 0 2px 8px rgba(33, 58, 49, 0.09);
}

.drive-search > svg {
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  fill: none;
  stroke: #61736c;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.drive-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #263b34;
  background: transparent;
  font-size: 13px;
}

.drive-search input::placeholder {
  color: #75857f;
}

.drive-search > button {
  width: 28px;
  height: 28px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 50%;
  place-items: center;
  color: #6e7d78;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
}

.drive-search > button:hover {
  background: #e7ecea;
}

.drive-command-bar {
  min-height: 56px;
  display: flex;
  align-items: center;
  padding: 8px 22px;
  background: #fbfcfc;
  gap: 12px;
}

.status-filters {
  min-width: 0;
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  overflow-x: auto;
  gap: 7px;
}

.status-filters button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0 11px;
  border: 1px solid #d6dfdb;
  border-radius: 8px;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  gap: 6px;
}

.status-filters button:hover {
  background: #f7f9f8;
}

.status-filters button.active {
  border-color: #7fae9d;
  color: #0d684e;
  background: #edf6f2;
  font-weight: 750;
}

.status-filters small {
  color: #6f7f78;
  font-size: 11px;
}

.list-utilities {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  margin-left: auto;
  gap: 7px;
}

.location-count {
  color: #697a73;
  font-size: 11px;
  white-space: nowrap;
}

.result-summary-link {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #bad6ca;
  border-radius: 8px;
  color: #146f50;
  background: #edf7f3;
  font-size: 11px;
  font-weight: 750;
  text-decoration: none;
  white-space: nowrap;
}

.result-summary-link:hover {
  border-color: #8fbeaa;
  background: #e2f2eb;
}

.command-icon-button {
  position: relative;
  width: 38px;
  height: 38px;
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 10px;
  place-items: center;
  color: #50645c;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  transition: 0.15s ease;
}

.command-icon-button:hover {
  color: #126149;
  background: #e9f0ed;
}

.command-icon-button:focus-visible {
  outline: 2px solid #4b957b;
  outline-offset: 2px;
}

.command-icon-button:disabled {
  cursor: default;
  opacity: 0.38;
}

.command-icon-button svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.command-icon-button[data-tooltip]::before, .command-icon-button[data-tooltip]::after {
  position: absolute;
  left: 50%;
  z-index: 24;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s ease;
}

.command-icon-button[data-tooltip]::before {
  bottom: calc(100% + 4px);
  border-width: 5px 5px 0;
  border-style: solid;
  border-color: #263b34 transparent transparent;
  content: "";
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]::after {
  bottom: calc(100% + 9px);
  padding: 6px 8px;
  border-radius: 6px;
  color: #fff;
  background: #263b34;
  box-shadow: 0 4px 12px rgba(25, 48, 40, 0.18);
  content: attr(data-tooltip);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  transform: translate(-50%, 3px);
}

.command-icon-button[data-tooltip]:hover::before, .command-icon-button[data-tooltip]:hover::after, .command-icon-button[data-tooltip]:focus-visible::before, .command-icon-button[data-tooltip]:focus-visible::after {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
}

.create-action-wrap {
  position: relative;
  flex: 0 0 auto;
  margin-left: 3px;
  padding-left: 10px;
  border-left: 1px solid #dfe6e3;
}

.create-primary {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  background: #176d54;
  box-shadow: 0 1px 2px rgba(18, 73, 56, 0.18);
}

.create-primary:hover:not(:disabled) {
  color: #fff;
  background: #105f49;
  transform: translateY(-1px);
}

.drive-content {
  min-height: 380px;
  flex: 1;
  padding: 22px;
}

.folder-loading-state {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667770;
  font-size: 13px;
  gap: 12px;
}

.state-spinner {
  width: 22px;
  height: 22px;
  display: inline-block;
  flex: 0 0 auto;
  border: 2px solid #d8e3de;
  border-top-color: #238361;
  border-radius: 50%;
  animation: state-spin 0.8s linear infinite;
}

@keyframes state-spin {
  to {
    transform: rotate(360deg);
  }
}
.inline-error {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px 13px;
  border: 1px solid #efd4d0;
  border-radius: 9px;
  color: #7c514d;
  background: #fff7f6;
  font-size: 11px;
  gap: 16px;
}

.inline-error span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.inline-error strong {
  margin-right: 6px;
  color: #944b45;
}

.inline-error button {
  flex: 0 0 auto;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid #dfbcb7;
  border-radius: 7px;
  color: #8d4841;
  background: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
}

.state-card {
  min-height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #d5dfdb;
  border-radius: 11px;
  color: #718078;
  background: #fff;
  text-align: center;
}

.state-card > strong {
  color: #34483f;
  font-size: 14px;
}

.state-card > span {
  margin-top: 5px;
  font-size: 11px;
}

.primary-link, .primary-button, .secondary-button {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  border-radius: 9px;
  padding: 0 13px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 750;
  text-decoration: none;
}

.primary-link, .primary-button {
  border: 0;
  color: #fff;
  background: #147b57;
}

.secondary-button {
  border: 1px solid #cfdbd5;
  color: #456158;
  background: #fff;
}

.drive-list {
  overflow: hidden;
  border: 1px solid #e0e7e4;
  border-radius: 11px;
  background: #fff;
}

.drive-head, .drive-row {
  width: 100%;
  display: grid;
  align-items: center;
  padding: 0 14px;
  grid-template-columns: minmax(220px, 1.5fr) 130px minmax(160px, 1fr) 130px 150px 82px;
  gap: 12px;
}

.drive-head {
  min-height: 42px;
  border-bottom: 1px solid #e2e8e5;
  color: #61736b;
  background: #fafbfb;
  font-size: 12px;
  font-weight: 700;
}

.drive-row {
  min-height: 64px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  color: #4f625a;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
}

.drive-row:last-of-type {
  border-bottom: 0;
}

.drive-row:hover {
  background: #f5f8f7;
}

.drive-row:focus-visible {
  outline: 2px solid #4b957b;
  outline-offset: -2px;
}

.dataset-card-region {
  overflow: hidden;
  border: 1px solid #e0e7e4;
  border-radius: 12px;
  background: #fff;
}

.dataset-card-grid {
  display: grid;
  padding: 16px;
  grid-template-columns: repeat(auto-fill, minmax(238px, 1fr));
  gap: 13px;
}

.dataset-card {
  min-width: 0;
  min-height: 196px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #dfe7e3;
  border-radius: 12px;
  outline: 0;
  background: #fff;
  box-shadow: 0 1px 2px rgba(29, 54, 45, 0.03);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.dataset-card:hover {
  border-color: #aacbbd;
  box-shadow: 0 9px 24px rgba(24, 66, 50, 0.09);
  transform: translateY(-2px);
}

.dataset-card:focus-visible {
  border-color: #4f9a7f;
  box-shadow: 0 0 0 3px rgba(40, 137, 102, 0.14);
}

.dataset-card-header {
  min-height: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.dataset-folder {
  position: relative;
  width: 56px;
  height: 40px;
  flex: 0 0 auto;
  border-radius: 8px;
  background: #dcefe7;
  box-shadow: inset 0 0 0 1px #bcd8cc;
}

.dataset-folder::before {
  position: absolute;
  top: -7px;
  left: 3px;
  width: 25px;
  height: 10px;
  border-radius: 6px 6px 0 0;
  background: #cae5da;
  box-shadow: inset 0 0 0 1px #b3d2c5;
  content: "";
}

.dataset-more-button {
  width: 32px;
  height: 32px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 8px;
  place-items: center;
  color: #6c7c75;
  background: transparent;
  cursor: pointer;
}

.dataset-more-button:hover {
  color: #176d54;
  background: #edf3f0;
}

.dataset-more-button:focus-visible {
  outline: 2px solid #4f9a7f;
  outline-offset: 1px;
}

.dataset-more-button svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.dataset-card-body {
  min-width: 0;
  margin-top: 13px;
}

.dataset-card-body > strong {
  display: block;
  overflow: hidden;
  color: #223a31;
  font-size: 14px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-card-body p {
  display: -webkit-box;
  min-height: 34px;
  overflow: hidden;
  margin: 6px 0 0;
  color: #708079;
  font-size: 11px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.dataset-card-metrics {
  display: flex;
  align-items: center;
  margin-top: 15px;
  gap: 15px;
}

.dataset-card-metrics span {
  color: #6b7d75;
  font-size: 10px;
}

.dataset-card-metrics strong {
  margin-right: 4px;
  color: #1c7656;
  font-size: 14px;
}

.dataset-card-footer {
  min-width: 0;
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #edf1ef;
  color: #7b8983;
  font-size: 9px;
  gap: 7px;
}

.dataset-card-footer span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-card-footer span:first-child {
  max-width: 44%;
}

.dataset-card-footer span + span::before {
  margin-right: 7px;
  color: #bcc6c2;
  content: "·";
}

.dataset-card-footer time {
  margin-left: auto;
  white-space: nowrap;
}

.dataset-context-menu {
  position: fixed;
  z-index: 88;
  width: 220px;
  padding: 6px;
  border: 1px solid #dce3e0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 16px 42px rgba(22, 43, 36, 0.18), 0 2px 8px rgba(22, 43, 36, 0.08);
  backdrop-filter: blur(12px);
}

.dataset-context-menu header {
  min-width: 0;
  margin-bottom: 4px;
  padding: 8px 10px 9px;
  border-bottom: 1px solid #edf0ef;
}

.dataset-context-menu header span, .dataset-context-menu header strong {
  display: block;
}

.dataset-context-menu header span {
  margin-bottom: 3px;
  color: #6f7f78;
  font-size: 10px;
}

.dataset-context-menu header strong {
  overflow: hidden;
  color: #2b4038;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-context-menu button {
  width: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  border: 0;
  border-radius: 6px;
  color: #40544d;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  text-align: left;
  gap: 10px;
}

.dataset-context-menu button:hover {
  background: #f0f3f2;
}

.dataset-context-menu button.danger {
  color: #a4433f;
}

.dataset-context-menu button.danger:hover {
  background: #fff3f2;
}

.dataset-context-menu button:disabled {
  cursor: default;
  opacity: 0.45;
}

.dataset-context-menu button svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.context-divider {
  height: 1px;
  margin: 5px 4px;
  background: #edf0ef;
}

.run-main, .run-status-cell, .candidate-result {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.run-main > strong {
  overflow: hidden;
  color: #263b32;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-main > small, .run-status-cell small, .candidate-result small {
  overflow: hidden;
  margin-top: 4px;
  color: #7f8d87;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 7px;
  border-radius: 6px;
  color: #61706a;
  background: #eef2f0;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.status i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
}

.status[data-status=QUEUED] {
  color: #5b6e93;
  background: #eef1f7;
}

.status[data-status=RUNNING] {
  color: #177657;
  background: #e5f4ed;
}

.status[data-status=COMPLETED] {
  color: #116c4a;
  background: #dcf2e7;
}

.status[data-status=FAILED] {
  color: #a34b43;
  background: #fae9e7;
}

.status[data-status=CANCELED] {
  color: #737a77;
  background: #f0f1f1;
}

.run-progress {
  min-width: 0;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  gap: 8px;
}

.run-progress > span {
  overflow: hidden;
  height: 6px;
  border-radius: 99px;
  background: #e6ece9;
}

.run-progress > span i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #26936c;
}

.run-progress > strong {
  color: #496057;
  font-size: 10px;
}

.candidate-result strong {
  color: #225740;
  font-size: 15px;
}

.run-date {
  color: #75847e;
  font-size: 11px;
}

.result-row-link {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c7dcd3;
  border-radius: 8px;
  color: #166c50;
  background: #f5faf8;
  font-size: 10px;
  font-weight: 750;
  text-decoration: none;
  white-space: nowrap;
}

.result-row-link:hover {
  border-color: #8fbeaa;
  background: #e5f3ed;
}

.result-row-link:focus-visible {
  outline: 2px solid #4b957b;
  outline-offset: 2px;
}

.row-arrow svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: #9aa6a1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.run-pagination {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-top: 1px solid #e8eeeb;
  color: #7d8b85;
  font-size: 11px;
}

.run-pagination > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.run-pagination button {
  width: 28px;
  height: 28px;
  border: 1px solid #d8e2dd;
  border-radius: 7px;
  color: #53675f;
  background: #fff;
  cursor: pointer;
}

.run-pagination button:disabled {
  cursor: default;
  opacity: 0.4;
}

.polling-note {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 10px 0 0;
  color: #5f756c;
  font-size: 10px;
}

.polling-note i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1b9a6c;
  box-shadow: 0 0 0 3px #d9eee5;
}

.dialog-backdrop {
  position: fixed;
  z-index: 80;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(20, 35, 29, 0.42);
  backdrop-filter: blur(2px);
}

.create-dialog {
  display: flex;
  width: min(880px, 96vw);
  max-height: 92vh;
  overflow: hidden;
  flex-direction: column;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(13, 32, 24, 0.25);
}

.generation-create-dialog {
  width: min(520px, 100vw - 32px);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px 17px;
  border-bottom: 1px solid #e6ece9;
}

.dialog-header span {
  color: #18815d;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.dialog-header h2 {
  margin: 4px 0 3px;
  font-size: 23px;
  letter-spacing: -0.035em;
}

.dialog-header p {
  margin: 0;
  color: #84918b;
  font-size: 9px;
}

.dialog-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #eef3f1;
  color: #53665e;
  cursor: pointer;
  font-size: 21px;
}

.dialog-steps {
  display: grid;
  grid-template-columns: 1fr 48px 1fr;
  align-items: center;
  padding: 13px 22px;
  border-bottom: 1px solid #edf1ef;
  background: #f8faf9;
}

.dialog-steps button {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #87938e;
  text-align: left;
}

.dialog-steps button:last-child {
  justify-content: flex-end;
}

.dialog-steps button > span {
  display: inline-flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e3e9e6;
  color: #718079;
  font-size: 9px;
}

.dialog-steps button strong {
  font-size: 10px;
}

.dialog-steps button.active, .dialog-steps button.done {
  color: #1a704f;
}

.dialog-steps button.active > span, .dialog-steps button.done > span {
  background: #1b805c;
  color: #fff;
}

.dialog-steps > i {
  height: 1px;
  background: #d7e1dc;
}

.dialog-body {
  overflow-y: auto;
  padding: 19px 22px;
}

.source-toolbar {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: flex-start;
  margin-bottom: 13px;
}

.source-toolbar > div:first-child strong {
  display: block;
  color: #294137;
  font-size: 13px;
}

.source-toolbar > div:first-child span {
  display: block;
  margin-top: 4px;
  color: #829089;
  font-size: 9px;
}

.selected-summary {
  flex: 0 0 auto;
  padding: 8px 11px;
  border-radius: 9px;
  background: #eef8f3;
  color: #277259;
}

.selected-summary strong {
  font-size: 16px;
}

.selected-summary span {
  margin-left: 4px;
  font-size: 9px;
}

.selected-summary button {
  margin-left: 9px;
  padding: 3px 6px;
  border: 0;
  border-radius: 5px;
  color: #35705a;
  background: #dcefe7;
  cursor: pointer;
  font-size: 8px;
}

.source-controls {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.source-picker-navigation {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 11px;
  padding: 8px;
  border: 1px solid #dfe7e3;
  border-radius: 10px;
  background: #f8faf9;
  gap: 10px;
}

.source-picker-breadcrumbs {
  min-width: 0;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
}

.source-picker-breadcrumbs button {
  max-width: 150px;
  overflow: hidden;
  flex: 0 1 auto;
  border: 0;
  padding: 5px 4px;
  color: #4f685e;
  background: transparent;
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-picker-breadcrumbs button:hover {
  color: #126149;
}

.source-picker-breadcrumbs svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  fill: none;
  stroke: #9aa7a1;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.source-picker-navigation .source-search {
  flex: 0 1 330px;
  background: #fff;
}

.source-search {
  display: flex;
  width: min(360px, 100%);
  height: 36px;
  align-items: center;
  border: 1px solid #d6e0db;
  border-radius: 9px;
  padding: 0 9px;
}

.source-search svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  fill: none;
  stroke: #7d8b85;
  stroke-width: 1.8;
}

.source-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  padding: 0 7px;
  color: #2e4039;
  font-size: 10px;
}

.source-search button {
  border: 0;
  background: transparent;
  color: #89968f;
  cursor: pointer;
}

.select-all-button {
  border: 1px solid #cedbd5;
  border-radius: 9px;
  padding: 0 12px;
  background: #fff;
  color: #3c6253;
  cursor: pointer;
  font-size: 9px;
  font-weight: 750;
}

.source-list {
  overflow: hidden;
  border: 1px solid #dfe7e3;
  border-radius: 11px;
}

.source-list-head, .source-list > button {
  display: grid;
  grid-template-columns: minmax(260px, 1.6fr) minmax(100px, 0.5fr) minmax(100px, 0.45fr) 28px;
  gap: 13px;
  align-items: center;
}

.source-list-head {
  min-height: 36px;
  padding: 0 12px;
  border-bottom: 1px solid #e8eeeb;
  background: #f7f9f8;
  color: #798780;
  font-size: 8px;
  font-weight: 750;
}

.source-list > button {
  width: 100%;
  min-height: 59px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  padding: 8px 12px;
  background: #fff;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.source-list > button:last-child {
  border-bottom: 0;
}

.source-list > button:hover, .source-list > button.selected {
  background: #f1faf6;
}

.source-name {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.document-shape {
  display: inline-flex;
  width: 31px;
  height: 35px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #bdd7ca;
  border-radius: 7px;
  background: #eff8f4;
  color: #267456;
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
}

.source-name > span, .source-version, .unit-count {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.source-name strong {
  overflow: hidden;
  color: #2c3e36;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-name small, .source-version small, .unit-count small {
  overflow: hidden;
  margin-top: 3px;
  color: #909b96;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.source-version strong, .unit-count strong {
  color: #476056;
  font-size: 10px;
}

.selection-mark {
  width: 17px;
  height: 17px;
  border: 1px solid #b9cbc2;
  border-radius: 5px;
}

.source-list > button.selected .selection-mark {
  border: 4px solid #e2f3eb;
  background: #17805b;
}

.source-folder-icon {
  position: relative;
  width: 32px;
  height: 23px;
  flex: 0 0 auto;
  border-radius: 5px;
  background: #dcefe7;
  box-shadow: inset 0 0 0 1px #bcd8cc;
}

.source-folder-icon::before {
  position: absolute;
  top: -4px;
  left: 2px;
  width: 14px;
  height: 6px;
  border-radius: 4px 4px 0 0;
  background: #cae5da;
  box-shadow: inset 0 0 0 1px #b3d2c5;
  content: "";
}

.dialog-empty {
  padding: 50px 20px;
  border: 1px dashed #cad7d1;
  border-radius: 11px;
  color: #84918b;
  font-size: 10px;
  text-align: center;
}

.input-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
  margin-bottom: 14px;
}

.input-summary article {
  padding: 12px 14px;
  border: 1px solid #deE7e3;
  border-radius: 10px;
  background: #f8faf9;
}

.input-summary span {
  color: #7b8983;
  font-size: 9px;
}

.input-summary strong {
  display: block;
  margin-top: 4px;
  color: #275c48;
  font-size: 16px;
}

.generation-count-field {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 120px auto;
  padding: 14px;
  border: 1px solid #dbe5e0;
  border-radius: 10px;
  background: #fff;
  gap: 12px;
}

.generation-count-field > span {
  color: #334b41;
  font-size: 12px;
  font-weight: 800;
}

.generation-count-field input {
  width: 120px;
  height: 42px;
  border: 1px solid #cad8d2;
  border-radius: 9px;
  outline: 0;
  padding: 0 10px;
  color: #263c33;
  background: #fff;
  font-size: 13px;
  text-align: right;
}

.generation-count-field input:focus {
  border-color: #57a88a;
  box-shadow: 0 0 0 3px rgba(41, 145, 106, 0.1);
}

.generation-count-field small {
  color: #7d8b85;
  font-size: 9px;
  white-space: nowrap;
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.settings-grid label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.settings-grid .full-field {
  grid-column: 1/-1;
}

.settings-grid label > span {
  color: #445a51;
  font-size: 10px;
  font-weight: 750;
}

.settings-grid label em {
  color: #1c805d;
  font-size: 8px;
  font-style: normal;
}

.settings-grid label > span small {
  margin-left: 4px;
  color: #93a09b;
  font-size: 8px;
  font-weight: 500;
}

.settings-grid input, .settings-grid select {
  width: 100%;
  height: 40px;
  border: 1px solid #d2ddd8;
  border-radius: 9px;
  outline: 0;
  padding: 0 11px;
  background: #fff;
  color: #2e4138;
  font-size: 11px;
}

.settings-grid textarea {
  width: 100%;
  min-height: 92px;
  resize: vertical;
  border: 1px solid #d2ddd8;
  border-radius: 9px;
  outline: 0;
  padding: 11px;
  background: #fff;
  color: #2e4138;
  font-size: 11px;
  line-height: 1.55;
}

.settings-grid input:focus, .settings-grid select:focus, .settings-grid textarea:focus {
  border-color: #57a88a;
  box-shadow: 0 0 0 3px rgba(41, 145, 106, 0.1);
}

.settings-grid label small {
  color: #8b9791;
  font-size: 8px;
  line-height: 1.45;
}

.dataset-organization-lock {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #e0e7e3;
  border-radius: 9px;
  background: #f8faf9;
}

.dataset-organization-lock span {
  color: #718079;
  font-size: 9px;
}

.dataset-organization-lock strong {
  color: #334b41;
  font-size: 11px;
}

.dataset-create-dialog {
  width: min(1120px, 100vw - 48px);
  height: min(720px, 90vh);
}

.dataset-create-dialog .dialog-header {
  flex: 0 0 auto;
  padding: 18px 22px;
}

.dataset-builder {
  min-height: 0;
  display: grid;
  overflow: hidden;
  flex: 1 1 auto;
  grid-template-columns: 300px minmax(0, 1fr);
}

.dataset-info-pane {
  min-height: 0;
  overflow-y: auto;
  padding: 18px;
  border-right: 1px solid #e5ebe8;
  background: #fbfcfb;
}

.dataset-info-pane .settings-grid {
  display: block;
}

.dataset-info-pane .settings-grid label {
  margin-bottom: 13px;
}

.dataset-info-pane .settings-grid label > span {
  font-size: 11px;
}

.dataset-info-pane .settings-grid input, .dataset-info-pane .settings-grid select {
  height: 41px;
  font-size: 12px;
}

.dataset-info-pane .settings-grid textarea {
  min-height: 86px;
  font-size: 12px;
}

.dataset-info-pane .dataset-organization-lock {
  margin-bottom: 13px;
  padding: 11px 12px;
}

.dataset-info-pane .dataset-organization-lock span {
  font-size: 10px;
}

.dataset-info-pane .dataset-organization-lock strong {
  max-width: 180px;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-scope-card {
  margin-top: 4px;
  padding: 12px;
  border: 1px solid #dde6e2;
  border-radius: 9px;
  background: #fff;
}

.dataset-scope-card header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dataset-scope-card header span {
  color: #60736b;
  font-size: 10px;
  font-weight: 750;
}

.dataset-scope-card header button {
  border: 0;
  padding: 2px;
  color: #52766a;
  background: transparent;
  cursor: pointer;
  font-size: 9px;
}

.dataset-scope-card > strong {
  display: flex;
  margin-top: 9px;
  color: #294a3d;
  font-size: 12px;
  gap: 12px;
}

.dataset-scope-card > strong b {
  font-weight: 750;
}

.dataset-source-pane {
  min-width: 0;
  min-height: 0;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: #fff;
}

.dataset-source-pane .source-toolbar {
  flex: 0 0 auto;
  align-items: center;
  margin: 0;
  padding: 16px 20px 11px;
}

.dataset-source-pane .source-toolbar > div:first-child strong {
  font-size: 14px;
}

.dataset-source-pane .selected-summary {
  padding: 7px 10px;
}

.dataset-source-pane .source-picker-navigation {
  flex: 0 0 auto;
  margin: 0 20px 12px;
}

.source-catalog-scroll {
  min-height: 0;
  overflow-y: auto;
  flex: 1 1 auto;
  padding: 0 20px 18px;
}

.source-browser-list {
  overflow: hidden;
  border: 1px solid #dfe7e3;
  border-radius: 11px;
  background: #fff;
}

.source-browser-head, .source-browser-row {
  display: grid;
  align-items: center;
  grid-template-columns: minmax(220px, 1.6fr) minmax(100px, 0.5fr) minmax(90px, 0.42fr) 52px;
  gap: 13px;
}

.source-browser-head {
  min-height: 38px;
  padding: 0 12px;
  border-bottom: 1px solid #e8eeeb;
  background: #f7f9f8;
  color: #798780;
  font-size: 9px;
  font-weight: 750;
}

.source-browser-row {
  width: 100%;
  min-height: 62px;
  border: 0;
  border-bottom: 1px solid #edf1ef;
  padding: 8px 12px;
  color: inherit;
  background: #fff;
  text-align: left;
}

.source-browser-row:last-of-type {
  border-bottom: 0;
}

.folder-browser-row:hover, .source-browser-row.selected, .document-browser-row:hover {
  background: #f1faf6;
}

.document-browser-row {
  cursor: pointer;
}

.browser-item-open {
  min-width: 0;
  display: flex;
  align-items: center;
  border: 0;
  padding: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
  text-align: left;
  gap: 10px;
}

.browser-item-open > span {
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
}

.browser-item-open strong {
  overflow: hidden;
  color: #2b4037;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.browser-item-open small {
  margin-top: 3px;
  color: #87938d;
  font-size: 9px;
}

.browser-item-open > svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  fill: none;
  stroke: #91a099;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.browser-item-info, .browser-item-unit {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.browser-item-info strong, .browser-item-unit strong {
  overflow: hidden;
  color: #476056;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.browser-item-info small {
  margin-top: 3px;
  color: #909b96;
  font-size: 8px;
}

.browser-item-select {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-left: 1px solid #edf1ef;
  background: transparent;
  cursor: pointer;
}

.browser-item-select.selected .selection-mark, .document-browser-row.selected .selection-mark {
  border: 4px solid #e2f3eb;
  background: #17805b;
}

.browser-item-select:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.source-browser-list .source-name strong {
  font-size: 11px;
}

.source-browser-list .source-name small, .source-browser-list .source-version small, .source-browser-list .unit-count small {
  font-size: 9px;
}

.document-select-state {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #778981;
}

.document-browser-row.selected .document-select-state {
  color: #167253;
}

.dataset-create-dialog .dialog-footer {
  flex: 0 0 auto;
  align-items: center;
  padding: 13px 20px;
}

.dialog-loading {
  min-height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7b74;
  font-size: 10px;
  gap: 10px;
}

.source-browser-list .run-pagination {
  border-top: 1px solid #e8eeeb;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 22px;
  border-top: 1px solid #e7ece9;
  background: #fafbfb;
}

.dialog-footer button {
  min-width: 90px;
  min-height: 39px;
  border-radius: 9px;
  padding: 0 14px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 750;
}

.cancel-action {
  border: 1px solid #d2ddd8;
  background: #fff;
  color: #53665e;
}

.continue-action {
  border: 0;
  background: #147b57;
  color: #fff;
}

.dialog-footer button:disabled {
  cursor: default;
  opacity: 0.48;
}

.detail-scrim {
  position: fixed;
  z-index: 70;
  inset: 0;
  background: rgba(17, 31, 26, 0.31);
}

.detail-panel {
  position: fixed;
  z-index: 71;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(700px, 94vw);
  overflow-y: auto;
  padding: 23px;
  background: #fff;
  box-shadow: -16px 0 44px rgba(17, 36, 29, 0.2);
}

.detail-loading {
  padding: 70px 20px;
  color: #6e7d76;
  text-align: center;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4ebe8;
}

.detail-header > div > span {
  color: #18815e;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.1em;
}

.detail-header h2 {
  margin: 4px 0 8px;
  font-size: 22px;
  letter-spacing: -0.03em;
}

.detail-header > button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #eef3f1;
  color: #4f625a;
  cursor: pointer;
  font-size: 22px;
}

.detail-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin: 16px 0;
}

.detail-summary article {
  padding: 12px;
  border: 1px solid #e1e9e5;
  border-radius: 10px;
}

.detail-summary span {
  color: #7d8b85;
  font-size: 9px;
}

.detail-summary strong {
  display: block;
  margin-top: 4px;
  color: #245640;
  font-size: 18px;
}

.stage-panel {
  padding: 15px;
  border-radius: 12px;
  background: #f6f9f8;
}

.stage-panel > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stage-panel > div span {
  color: #18815e;
  font-size: 9px;
  font-weight: 850;
}

.stage-panel > div strong {
  color: #375048;
  font-size: 11px;
}

.stage-panel ol {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.stage-panel li {
  min-width: 0;
}

.stage-panel li > i {
  display: block;
  height: 6px;
  border-radius: 99px;
  background: #dfe6e3;
}

.stage-panel li[data-state=RUNNING] > i {
  background: #4a9ed2;
}

.stage-panel li[data-state=SUCCEEDED] > i {
  background: #26a574;
}

.stage-panel li[data-state=FAILED] > i {
  background: #d75f54;
}

.stage-panel li span {
  display: block;
  margin-top: 6px;
}

.stage-panel li strong {
  display: block;
  overflow: hidden;
  color: #556760;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stage-panel li small {
  color: #9aa39f;
  font-size: 7px;
}

.error-panel {
  margin-top: 13px;
  padding: 12px;
  border-radius: 10px;
  background: #fff0ee;
  color: #9b4a43;
}

.error-panel > span {
  display: block;
  margin-bottom: 5px;
  font-size: 8px;
  font-weight: 800;
}

.error-panel strong {
  font-family: monospace;
  font-size: 10px;
}

.error-panel p {
  margin: 4px 0 0;
  font-size: 10px;
  line-height: 1.45;
}

.detail-section {
  margin-top: 15px;
}

.detail-section > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.detail-section > header span {
  color: #365148;
  font-size: 10px;
  font-weight: 800;
}

.detail-section > header strong {
  color: #75847d;
  font-size: 9px;
}

.detail-section dl {
  margin: 0;
  border: 1px solid #e1e8e5;
  border-radius: 11px;
}

.detail-section dl div {
  display: grid;
  grid-template-columns: 105px 1fr;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf1ef;
}

.detail-section dl div:last-child {
  border-bottom: 0;
}

.detail-section dt {
  color: #82908a;
  font-size: 9px;
}

.detail-section dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #354941;
  font-size: 10px;
}

.detail-section code {
  color: #177856;
  font-size: 8px;
}

.technical-detail {
  margin-top: 8px;
}

.technical-detail summary {
  color: #75847e;
  cursor: pointer;
  font-size: 9px;
}

.technical-detail[open] summary {
  margin-bottom: 8px;
}

.snapshot-panel article {
  display: grid;
  grid-template-columns: 50px 1fr auto;
  gap: 9px;
  align-items: center;
  padding: 9px;
  border-top: 1px solid #e4ebe8;
}

.snapshot-panel article:nth-child(2) {
  border-top: 0;
}

.snapshot-version {
  color: #2d7c60;
  font-size: 9px;
  font-weight: 800;
}

.snapshot-panel article strong {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.snapshot-panel article small {
  color: #8b9792;
  font-size: 8px;
}

.detail-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 17px;
  padding-top: 14px;
  border-top: 1px solid #e5ebe8;
}

.detail-footer a, .detail-footer button {
  border: 0;
  border-radius: 9px;
  padding: 10px 13px;
  font-size: 9px;
  font-weight: 750;
  text-decoration: none;
}

.candidate-link {
  margin-right: auto;
  background: #e5f3ed;
  color: #177452;
}

.retry-button {
  background: #e4f5ed;
  color: #177452;
}

.cancel-button {
  background: #f8eae8;
  color: #a04d46;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
}

@media (max-width: 1120px) {
  .drive-head, .drive-row {
    grid-template-columns: minmax(190px, 1.2fr) 120px minmax(150px, 1fr) 105px 82px;
  }
  .drive-head > span:nth-child(5), .run-date {
    display: none;
  }
}
@media (max-width: 820px) {
  .generation-drive {
    padding: 20px 18px 32px;
  }
  .drive-navigation-bar {
    align-items: stretch;
    flex-direction: column;
    padding: 14px 18px;
    gap: 10px;
  }
  .navigation-tools, .drive-search {
    width: 100%;
    max-width: none;
    flex-basis: auto;
  }
  .drive-command-bar {
    flex-wrap: wrap;
    padding-right: 18px;
    padding-left: 18px;
  }
  .status-filters {
    flex: 1 1 auto;
  }
  .drive-head, .drive-row {
    grid-template-columns: minmax(190px, 1fr) 120px minmax(130px, 0.8fr) 82px;
  }
  .drive-head > span:nth-child(4), .drive-head > span:nth-child(5), .candidate-result, .run-date {
    display: none;
  }
  .dataset-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .source-picker-navigation {
    align-items: stretch;
    flex-direction: column;
  }
  .source-picker-navigation .source-search {
    width: 100%;
    max-width: none;
    flex-basis: auto;
  }
  .dialog-backdrop {
    padding: 12px;
  }
  .create-dialog {
    width: 100%;
    max-height: 96vh;
  }
  .dataset-create-dialog {
    height: 96vh;
  }
  .dataset-builder {
    display: flex;
    overflow-y: auto;
    flex-direction: column;
  }
  .dataset-info-pane {
    overflow: visible;
    flex: 0 0 auto;
    border-right: 0;
    border-bottom: 1px solid #e5ebe8;
  }
  .dataset-source-pane {
    min-height: 480px;
    overflow: visible;
    flex: 1 0 auto;
  }
  .source-catalog-scroll {
    min-height: 320px;
  }
  .stage-panel ol {
    grid-template-columns: 1fr;
  }
  .stage-panel li {
    display: grid;
    grid-template-columns: 8px 1fr;
    gap: 8px;
    align-items: start;
  }
  .stage-panel li > i {
    width: 8px;
    height: 8px;
    margin-top: 6px;
  }
  .stage-panel li span {
    margin-top: 0;
  }
}
@media (max-width: 560px) {
  .generation-drive {
    padding: 16px 12px 28px;
  }
  .drive-shell {
    min-height: 0;
  }
  .drive-navigation-bar {
    padding: 12px 14px;
  }
  .drive-command-bar {
    min-height: 0;
    flex-wrap: wrap;
    padding: 9px 14px;
  }
  .drive-content {
    padding: 14px;
  }
  .location-count {
    display: none;
  }
  .dataset-card-grid {
    padding: 10px;
    grid-template-columns: 1fr;
  }
  .dataset-card {
    min-height: 184px;
  }
  .drive-head {
    display: none;
  }
  .drive-row {
    grid-template-columns: 1fr 82px;
    padding: 12px;
    gap: 8px;
  }
  .run-status-cell {
    grid-column: 1;
    grid-row: 2;
  }
  .run-progress {
    grid-column: 1/-1;
    grid-row: 3;
  }
  .row-arrow, .result-row-link {
    grid-column: 2;
    grid-row: 1;
  }
  .run-pagination {
    gap: 10px;
  }
  .inline-error {
    align-items: flex-start;
    flex-direction: column;
  }
  .source-controls, .source-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .source-search {
    width: 100%;
  }
  .dialog-header, .dialog-body, .dialog-footer {
    padding-right: 15px;
    padding-left: 15px;
  }
  .dialog-steps {
    padding-right: 15px;
    padding-left: 15px;
  }
  .source-list-head {
    display: none;
  }
  .source-list > button {
    grid-template-columns: 1fr 22px;
  }
  .source-version, .unit-count {
    display: none;
  }
  .source-browser-head {
    display: none;
  }
  .source-browser-row {
    grid-template-columns: minmax(0, 1fr) 44px;
    gap: 8px;
  }
  .source-browser-row .browser-item-info, .source-browser-row .browser-item-unit, .source-browser-row .source-version, .source-browser-row .unit-count {
    display: none;
  }
  .browser-item-select {
    min-height: 40px;
    border-left: 0;
  }
  .settings-grid, .input-summary, .detail-summary {
    grid-template-columns: 1fr 1fr;
  }
  .settings-grid label, .settings-grid .full-field {
    grid-column: 1/-1;
  }
  .generation-count-field {
    grid-template-columns: 1fr auto;
  }
  .generation-count-field input {
    grid-column: 1/-1;
    width: 100%;
    text-align: left;
  }
  .detail-panel {
    width: 100%;
    padding: 16px;
  }
  .snapshot-panel article {
    grid-template-columns: 44px 1fr;
  }
  .snapshot-panel article small {
    grid-column: 2;
  }
  .detail-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .candidate-link {
    margin-right: 0;
    text-align: center;
  }
}`],
})
export class PageAuthoringRunsComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public creating: boolean = false;
    public datasetCreating: boolean = false;
    public datasetArchiving: boolean = false;
    public sourceOrganizationLoading: boolean = false;
    public sourceCatalogLoading: boolean = false;
    public detailLoading: boolean = false;
    public showCreateDialog: boolean = false;
    public showDatasetDialog: boolean = false;
    public viewMode: string = 'DATASETS';
    public datasetSourceQuery: string = '';
    public runQuery: string = '';
    public datasetQuery: string = '';
    public runStatusFilter: string = 'ALL';
    public loadError: string = '';
    public runPage: number = 1;
    public runPageSize: number = 10;
    public datasetPage: number = 1;
    public datasetPageSize: number = 10;
    public datasetSourcePage: number = 1;
    public datasetSourcePageSize: number = 10;
    public runs: any[] = [];
    public inputSummary: any = {
        text_unit_count: 0,
        source_document_count: 0,
        source_version_count: 0,
        source_groups: {}
    };
    public datasets: any[] = [];
    public sourceOrganizations: any[] = [];
    public sourceCatalogAssets: any[] = [];
    public sourceCatalogFolders: any[] = [];
    public sourceCatalogBreadcrumbs: any[] = [];
    public sourceCatalogCurrentFolder: any = null;
    public sourceCatalogDocumentTotal: number = 0;
    public sourceCatalogHasMore: boolean = false;
    public datasetDialogMode: string = 'CREATE';
    public editingDataset: any = null;
    public datasetMenu: any = {
        visible: false,
        x: 0,
        y: 0,
        dataset: null
    };
    public workspaceDataset: any = null;
    public profile: any = {};
    public selected: any = null;
    public form: any = this.newForm();
    public datasetForm: any = this.newDatasetForm();
    public pollingTimer: any = null;
    public datasetSourceSearchTimer: any = null;
    public stages: string[] = [
        'INDEXING', 'KEYWORDING', 'GROUNDING', 'EVIDENCE_SELECTING',
        'QA_GENERATING', 'VALIDATING', 'WRITING_OUTPUTS'
    ];
    public statusOptions: any[] = [
        { value: 'ALL', label: '전체 상태' },
        { value: 'QUEUED', label: '대기' },
        { value: 'RUNNING', label: '진행 중' },
        { value: 'COMPLETED', label: '완료' },
        { value: 'FAILED', label: '실패' },
        { value: 'CANCELED', label: '취소' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public newForm() {
        return {
            run_name: 'QA 생성 ' + formatKstDate(new Date(), ''),
            target_count: 10,
            idempotency_key: 'run-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 10)
        };
    }

    public async ngOnInit() {
        await this.service.init();
        let params = new URLSearchParams(location.search);
        let requestedDatasetId = params.get('dataset_id') || '';
        let requestedRunId = params.get('run_id') || '';
        await this.loadDatasets(false);
        if (requestedDatasetId) {
            let dataset = this.datasets.find(
                (item: any) => item.id === requestedDatasetId
            );
            if (dataset) {
                await this.openDataset(dataset);
                if (requestedRunId) {
                    let run = this.runs.find(
                        (item: any) => item.id === requestedRunId
                    );
                    if (run) await this.openDetail(run, false);
                }
            }
        }
        this.pollingTimer = window.setInterval(() => this.poll(), 5000);
    }

    public ngOnDestroy() {
        if (this.pollingTimer) window.clearInterval(this.pollingTimer);
        if (this.datasetSourceSearchTimer) window.clearTimeout(this.datasetSourceSearchTimer);
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    public newDatasetForm() {
        return {
            name: '새 QA 데이터셋 ' + formatKstDate(new Date(), '.'),
            description: '',
            organization_id: '',
            source_folder_ids: [],
            source_asset_ids: []
        };
    }

    public isSystemAdmin() {
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN';
    }

    public canCreate() {
        let roles = this.currentDataset().roles || [];
        return this.isSystemAdmin()
            || roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('AUTHOR') >= 0
            || roles.indexOf('GENERATION_OPERATOR') >= 0;
    }

    public hasActiveRuns() {
        return this.viewMode === 'RUNS' && this.runs.some(
            (run: any) => run.status === 'QUEUED' || run.status === 'RUNNING'
        );
    }

    public activeRunCount() {
        return this.runs.filter(
            (run: any) => run.status === 'QUEUED' || run.status === 'RUNNING'
        ).length;
    }

    public completedRunCount() {
        return this.runs.filter((run: any) => run.status === 'COMPLETED').length;
    }

    public totalCandidateCount() {
        return this.runs.reduce(
            (total: number, run: any) => total + Number((run.candidate_summary || {}).total || 0),
            0
        );
    }

    public candidateQuery(runId: string = '') {
        let query: any = {
            dataset_id: this.currentDataset().dataset_id
        };
        if (runId) query.run_id = runId;
        return query;
    }

    private syncGenerationUrl(runId: string = '') {
        let params = new URLSearchParams();
        let datasetId = this.currentDataset().dataset_id || '';
        if (datasetId) params.set('dataset_id', datasetId);
        if (runId) params.set('run_id', runId);
        let query = params.toString();
        history.replaceState(
            {},
            '',
            '/authoring/runs' + (query ? '?' + query : '')
        );
    }

    public eligibleUnitCount() {
        return Number(this.inputSummary.text_unit_count || 0);
    }

    public async poll() {
        if (this.viewMode === 'RUNS' && this.hasActiveRuns() && !this.loading && !this.creating) {
            await this.load(true);
            if (this.selected) await this.openDetail(this.selected, true);
        }
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    private async showQueued(message: string) {
        await this.service.modal.show({
            title: '대기열 등록 완료',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'success',
            status: 'success'
        });
    }

    public filteredDatasets() {
        let query = this.normalize(this.datasetQuery);
        if (!query) return this.datasets;
        return this.datasets.filter((dataset: any) => this.normalize([
            dataset.name,
            dataset.description,
            dataset.organization_name
        ].join(' ')).indexOf(query) >= 0);
    }

    public visibleDatasets() {
        let start = (this.datasetPage - 1) * this.datasetPageSize;
        return this.filteredDatasets().slice(start, start + this.datasetPageSize);
    }

    public datasetPageCount() {
        return Math.max(1, Math.ceil(this.filteredDatasets().length / this.datasetPageSize));
    }

    public datasetPageStart() {
        return this.filteredDatasets().length
            ? (this.datasetPage - 1) * this.datasetPageSize + 1
            : 0;
    }

    public datasetPageEnd() {
        return Math.min(this.datasetPage * this.datasetPageSize, this.filteredDatasets().length);
    }

    public updateDatasetSearch() {
        this.datasetPage = 1;
    }

    public clearDatasetSearch() {
        this.datasetQuery = '';
        this.datasetPage = 1;
    }

    public changeDatasetPage(direction: number) {
        this.datasetPage = Math.max(
            1,
            Math.min(this.datasetPageCount(), this.datasetPage + direction)
        );
    }

    public datasetRoleLabel(dataset: any) {
        let labels: any = {
            DATASET_ADMIN: '관리자',
            AUTHOR: '저작자',
            GENERATION_OPERATOR: '생성 운영자',
            REVIEW_ADMIN: '검수 관리자',
            RELEASE_ADMIN: '배포 관리자'
        };
        let roles = (dataset.roles || []).map((role: string) => labels[role] || role);
        return roles.length ? roles.slice(0, 2).join(' · ') : '조회';
    }

    public canManageDataset(dataset: any) {
        return this.isSystemAdmin()
            || !!(
                dataset
                && (dataset.roles || []).indexOf('DATASET_ADMIN') >= 0
            );
    }

    public formatDatasetDate(value: any) {
        return formatKstDate(value, '');
    }

    public async openDatasetMenu(event: any, dataset: any, fromButton: boolean = false) {
        event.preventDefault();
        event.stopPropagation();
        let menuWidth = 220;
        let menuHeight = this.canManageDataset(dataset) ? 196 : 84;
        let x = event.clientX;
        let y = event.clientY;
        if (fromButton && event.currentTarget) {
            let rect = event.currentTarget.getBoundingClientRect();
            x = rect.right - menuWidth;
            y = rect.bottom + 6;
        }
        this.datasetMenu = {
            visible: true,
            x: Math.max(8, Math.min(x, window.innerWidth - menuWidth - 8)),
            y: Math.max(8, Math.min(y, window.innerHeight - menuHeight - 8)),
            dataset: dataset
        };
        await this.service.render();
    }

    public async closeDatasetMenu() {
        if (!this.datasetMenu.visible) return;
        this.datasetMenu.visible = false;
        await this.service.render();
    }

    public async openDatasetFromMenu(event: any) {
        event.preventDefault();
        event.stopPropagation();
        let dataset = this.datasetMenu.dataset;
        this.datasetMenu.visible = false;
        await this.openDataset(dataset);
    }

    public async editDatasetFromMenu(event: any) {
        event.preventDefault();
        event.stopPropagation();
        let dataset = this.datasetMenu.dataset;
        this.datasetMenu.visible = false;
        await this.openDatasetDialog(dataset);
    }

    public async manageDatasetMembers(event: any) {
        event.preventDefault();
        event.stopPropagation();
        let dataset = this.datasetMenu.dataset;
        this.datasetMenu.visible = false;
        if (!dataset || !this.canManageDataset(dataset)) return;
        let result: any = await this.service.request.post('/api/datasets/select', {
            dataset_id: dataset.id
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message
                    ? result.data.message
                    : '데이터셋 권한 관리 화면을 열지 못했습니다.'
            );
            return;
        }
        let access = result.data.access || {};
        this.service.auth.session.current_dataset = access.current_dataset || {};
        this.service.auth.session.dataset_roles = access.dataset_roles || [];
        this.service.auth.session.portals = access.portals || this.service.auth.session.portals;
        this.service.href('/authoring/datasets');
    }

    public async archiveDatasetFromMenu(event: any) {
        event.preventDefault();
        event.stopPropagation();
        let dataset = this.datasetMenu.dataset;
        this.datasetMenu.visible = false;
        if (!dataset || !this.canManageDataset(dataset) || this.datasetArchiving) return;
        let confirmed = await this.service.modal.show({
            title: 'QA 데이터셋 보관',
            message: dataset.name + ' 데이터셋을 목록에서 보관하시겠습니까? 기존 QA와 실행 이력은 삭제되지 않습니다.',
            cancel: '취소',
            action: '보관',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        this.datasetArchiving = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/datasets/archive', {
                dataset_id: dataset.id
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'QA 데이터셋을 보관하지 못했습니다.'
                );
                return;
            }
            let access = result.data.access || {};
            this.service.auth.session.current_dataset = access.current_dataset || {};
            this.service.auth.session.dataset_roles = access.dataset_roles || [];
            this.service.auth.session.portals = access.portals || this.service.auth.session.portals;
            await this.loadDatasets(true);
        } finally {
            this.datasetArchiving = false;
            await this.service.render();
        }
    }

    public async loadDatasets(quiet: boolean = false) {
        if (!quiet) {
            this.loadError = '';
            this.loading = true;
            await this.service.render();
        }
        try {
            let result: any = await this.service.request.post('/api/datasets/list');
            if (result.code !== 200) {
                if (!quiet) {
                    this.loadError = result.data && result.data.message
                        ? String(result.data.message)
                        : '잠시 후 다시 시도해 주세요.';
                }
                return;
            }
            this.loadError = '';
            this.datasets = result.data.datasets || [];
            this.datasetPage = Math.min(this.datasetPage, this.datasetPageCount());
        } catch (error) {
            if (!quiet) this.loadError = '서버 연결을 확인한 뒤 다시 시도해 주세요.';
        } finally {
            if (!quiet) this.loading = false;
            await this.service.render();
        }
    }

    public async openDataset(dataset: any) {
        if (!dataset || !dataset.id || this.loading) return;
        this.datasetMenu.visible = false;
        this.loading = true;
        this.loadError = '';
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/datasets/select', {
                dataset_id: dataset.id
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'QA 데이터셋을 열지 못했습니다.'
                );
                return;
            }
            let access = result.data.access || {};
            this.service.auth.session.current_dataset = access.current_dataset || {};
            this.service.auth.session.dataset_roles = access.dataset_roles || [];
            this.service.auth.session.portals = access.portals || this.service.auth.session.portals;
            this.workspaceDataset = dataset;
            this.viewMode = 'RUNS';
            this.runs = [];
            this.inputSummary = {
                text_unit_count: 0,
                source_document_count: 0,
                source_version_count: 0,
                source_groups: {}
            };
            this.runQuery = '';
            this.runStatusFilter = 'ALL';
            this.runPage = 1;
            this.loading = false;
            this.syncGenerationUrl();
            await this.load(false);
        } finally {
            if (this.viewMode !== 'RUNS') {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    public async showDatasetRoot() {
        this.datasetMenu.visible = false;
        this.viewMode = 'DATASETS';
        this.workspaceDataset = null;
        this.selected = null;
        this.detailLoading = false;
        this.showCreateDialog = false;
        this.runs = [];
        history.replaceState({}, '', '/authoring/runs');
        await this.loadDatasets(false);
    }

    public async openDatasetDialog(dataset: any = null) {
        if (dataset && !this.canManageDataset(dataset)) return;
        if (!dataset && !this.isSystemAdmin()) return;
        let currentId = this.currentDataset().dataset_id;
        let current = this.datasets.find((dataset: any) => dataset.id === currentId);
        this.datasetDialogMode = dataset ? 'EDIT' : 'CREATE';
        this.editingDataset = dataset || null;
        this.datasetForm = dataset
            ? {
                name: dataset.name || '',
                description: dataset.description || '',
                organization_id: dataset.organization_id || '',
                source_folder_ids: (dataset.source_folder_ids || []).slice(),
                source_asset_ids: (dataset.source_asset_ids || []).slice()
            }
            : this.newDatasetForm();
        if (!dataset) this.datasetForm.organization_id = current ? current.organization_id : '';
        this.datasetSourceQuery = '';
        this.datasetSourcePage = 1;
        this.sourceCatalogAssets = [];
        this.sourceCatalogFolders = [];
        this.sourceCatalogBreadcrumbs = [];
        this.sourceCatalogCurrentFolder = null;
        this.sourceCatalogDocumentTotal = 0;
        this.sourceCatalogHasMore = false;
        this.datasetMenu.visible = false;
        this.showDatasetDialog = true;
        await this.service.render();
        let organizationRequest = this.loadDatasetOrganizations();
        if (this.datasetForm.organization_id) {
            await Promise.all([
                organizationRequest,
                this.loadDatasetSourceCatalog()
            ]);
        } else {
            await organizationRequest;
            if (this.datasetForm.organization_id) {
                await this.loadDatasetSourceCatalog();
            }
        }
    }

    public async closeDatasetDialog() {
        if (this.datasetCreating) return;
        if (this.datasetSourceSearchTimer) {
            window.clearTimeout(this.datasetSourceSearchTimer);
            this.datasetSourceSearchTimer = null;
        }
        this.showDatasetDialog = false;
        this.editingDataset = null;
        await this.service.render();
    }

    public datasetDialogTitle() {
        return this.datasetDialogMode === 'EDIT'
            ? 'QA 데이터셋 수정'
            : '새 QA 데이터셋';
    }

    public datasetSelectionCount() {
        return this.datasetForm.source_folder_ids.length
            + this.datasetForm.source_asset_ids.length;
    }

    public datasetSelectedFolderCount() {
        return this.datasetForm.source_folder_ids.length;
    }

    public datasetSelectedAssetCount() {
        return this.datasetForm.source_asset_ids.length;
    }

    public selectedSourceOrganizationName() {
        if (this.datasetDialogMode === 'EDIT' && this.editingDataset) {
            return this.editingDataset.organization_name || '-';
        }
        let selected = this.sourceOrganizations.find(
            (organization: any) => organization.id === this.datasetForm.organization_id
        );
        if (selected) return selected.name;
        return this.sourceOrganizationLoading ? '불러오는 중' : '-';
    }

    public datasetCanSave() {
        return !this.datasetCreating
            && !this.sourceCatalogLoading
            && !!this.datasetForm.organization_id
            && !!this.datasetForm.name
            && this.datasetForm.name.trim().length >= 2
            && this.datasetSelectionCount() > 0;
    }

    public async loadDatasetOrganizations() {
        if (this.sourceOrganizations.length) {
            let selected = this.sourceOrganizations.find(
                (organization: any) => organization.id === this.datasetForm.organization_id
            ) || this.sourceOrganizations[0];
            this.datasetForm.organization_id = selected ? selected.id : '';
            return;
        }
        this.sourceOrganizationLoading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post(
                '/api/sources/catalog/organizations',
                { organization_id: this.datasetForm.organization_id }
            );
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '원천 데이터 기관을 불러오지 못했습니다.'
                );
                return;
            }
            this.sourceOrganizations = result.data.organizations || [];
            let selected = result.data.selected_organization || {};
            this.datasetForm.organization_id = selected.id || '';
        } finally {
            this.sourceOrganizationLoading = false;
            await this.service.render();
        }
    }

    public async changeDatasetOrganization(organizationId: string) {
        this.datasetForm.organization_id = organizationId;
        this.datasetForm.source_folder_ids = [];
        this.datasetForm.source_asset_ids = [];
        this.sourceCatalogAssets = [];
        this.sourceCatalogFolders = [];
        this.sourceCatalogBreadcrumbs = [];
        this.sourceCatalogCurrentFolder = null;
        this.sourceCatalogDocumentTotal = 0;
        this.sourceCatalogHasMore = false;
        this.datasetSourceQuery = '';
        this.datasetSourcePage = 1;
        if (this.showDatasetDialog) await this.loadDatasetSourceCatalog();
    }

    public async loadDatasetSourceCatalog() {
        this.sourceCatalogLoading = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/sources/catalog/assets', {
                organization_id: this.datasetForm.organization_id,
                folder_id: this.sourceCatalogCurrentFolder
                    ? this.sourceCatalogCurrentFolder.id
                    : '',
                query: this.datasetSourceQuery,
                offset: (this.datasetSourcePage - 1) * this.datasetSourcePageSize,
                limit: this.datasetSourcePageSize
            });
            if (result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : '원천 문서를 불러오지 못했습니다.'
                );
                return;
            }
            this.sourceCatalogAssets = result.data.assets || [];
            this.sourceCatalogFolders = result.data.folders || [];
            this.sourceCatalogBreadcrumbs = result.data.breadcrumbs || [];
            this.sourceCatalogCurrentFolder = result.data.current_folder || null;
            this.sourceCatalogDocumentTotal = Number(result.data.document_total || 0);
            this.sourceCatalogHasMore = !!result.data.has_more;
            let selectedOrganization = result.data.selected_organization || {};
            if (selectedOrganization.id) {
                this.datasetForm.organization_id = selectedOrganization.id;
            }
        } finally {
            this.sourceCatalogLoading = false;
            await this.service.render();
        }
    }

    public filteredDatasetSources() {
        return this.sourceCatalogAssets;
    }

    public visibleDatasetSources() {
        return this.sourceCatalogAssets;
    }

    public async openDatasetSourceRoot() {
        this.sourceCatalogCurrentFolder = null;
        this.datasetSourceQuery = '';
        this.datasetSourcePage = 1;
        await this.loadDatasetSourceCatalog();
    }

    public async openDatasetSourceFolder(folder: any) {
        if (!folder || !folder.id) return;
        this.sourceCatalogCurrentFolder = { id: folder.id, name: folder.name };
        this.datasetSourceQuery = '';
        this.datasetSourcePage = 1;
        await this.loadDatasetSourceCatalog();
    }

    public async openDatasetSourceBreadcrumb(folder: any) {
        if (!folder || !folder.id) {
            await this.openDatasetSourceRoot();
            return;
        }
        await this.openDatasetSourceFolder(folder);
    }

    public updateDatasetSourceSearch() {
        this.datasetSourcePage = 1;
        if (this.datasetSourceSearchTimer) window.clearTimeout(this.datasetSourceSearchTimer);
        this.datasetSourceSearchTimer = window.setTimeout(
            () => {
                this.datasetSourceSearchTimer = null;
                this.loadDatasetSourceCatalog();
            },
            250
        );
    }

    public async clearDatasetSourceSearch() {
        this.datasetSourceQuery = '';
        this.datasetSourcePage = 1;
        if (this.datasetSourceSearchTimer) window.clearTimeout(this.datasetSourceSearchTimer);
        this.datasetSourceSearchTimer = null;
        await this.loadDatasetSourceCatalog();
    }

    public async changeDatasetSourcePage(direction: number) {
        if (direction > 0 && !this.sourceCatalogHasMore) return;
        this.datasetSourcePage = Math.max(1, this.datasetSourcePage + direction);
        await this.loadDatasetSourceCatalog();
    }

    public datasetSourceSelected(assetId: string) {
        return this.datasetForm.source_asset_ids.indexOf(assetId) >= 0;
    }

    public datasetSourceFolderSelected(folderId: string) {
        return this.datasetForm.source_folder_ids.indexOf(folderId) >= 0;
    }

    public datasetSourceFolderSelectable(folder: any) {
        let documentCount = Number(folder && folder.document_count || 0);
        let readyCount = Number(folder && folder.ready_count || 0);
        return !!folder
            && documentCount > 0
            && readyCount > 0;
    }

    public datasetSourceFolderStatus(folder: any) {
        let documentCount = Number(folder && folder.document_count || 0);
        let readyCount = Number(folder && folder.ready_count || 0);
        if (!folder || !documentCount) return '문서 없음';
        if (!readyCount) return '준비 중';
        return readyCount === documentCount
            ? '전체 TextUnit 사용 가능'
            : '준비된 문서 ' + readyCount + '개 사용';
    }

    public async toggleDatasetSourceFolder(event: any, folder: any) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.datasetSourceFolderSelectable(folder)) {
            await this.showError(
                folder.document_count
                    ? '이 폴더에는 QA 생성에 사용할 READY TextUnit이 없습니다.'
                    : '문서가 없는 폴더는 선택할 수 없습니다.'
            );
            return;
        }
        let selected = this.datasetForm.source_folder_ids;
        let index = selected.indexOf(folder.id);
        if (index >= 0) selected.splice(index, 1);
        else {
            if (this.datasetSelectionCount() >= 200) {
                await this.showError('원천 폴더와 문서는 합해 최대 200개까지 선택할 수 있습니다.');
                return;
            }
            selected.push(folder.id);
        }
        this.datasetForm.source_folder_ids = selected.slice();
        await this.service.render();
    }

    public async toggleDatasetSource(asset: any) {
        let selected = this.datasetForm.source_asset_ids;
        let index = selected.indexOf(asset.id);
        if (index >= 0) {
            selected.splice(index, 1);
        } else {
            if (this.datasetSelectionCount() >= 200) {
                await this.showError('원천 폴더와 문서는 합해 최대 200개까지 선택할 수 있습니다.');
                return;
            }
            selected.push(asset.id);
        }
        this.datasetForm.source_asset_ids = selected.slice();
        await this.service.render();
    }

    public async clearDatasetSourceSelection() {
        this.datasetForm.source_folder_ids = [];
        this.datasetForm.source_asset_ids = [];
        await this.service.render();
    }

    public async saveDataset() {
        if (this.datasetCreating) return;
        if (!this.datasetForm.name || this.datasetForm.name.trim().length < 2) {
            await this.showError('QA 데이터셋 이름을 2자 이상 입력해 주세요.');
            return;
        }
        if (!this.datasetForm.organization_id) {
            await this.showError('원천 데이터 기관을 선택해 주세요.');
            return;
        }
        if (!this.datasetSelectionCount()) {
            await this.showError('QA 데이터셋에 사용할 원천 폴더 또는 문서를 하나 이상 선택해 주세요.');
            return;
        }
        this.datasetCreating = true;
        await this.service.render();
        try {
            let editing = this.datasetDialogMode === 'EDIT';
            let result: any = await this.service.request.post(
                editing ? '/api/datasets/update' : '/api/datasets/create',
                {
                dataset_id: editing && this.editingDataset ? this.editingDataset.id : '',
                name: this.datasetForm.name,
                description: this.datasetForm.description,
                organization_id: this.datasetForm.organization_id,
                source_folder_ids: this.datasetForm.source_folder_ids.join(','),
                source_asset_ids: this.datasetForm.source_asset_ids.join(',')
                }
            );
            if (result.code !== (editing ? 200 : 201)) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : (editing
                            ? 'QA 데이터셋을 수정하지 못했습니다.'
                            : 'QA 데이터셋을 만들지 못했습니다.')
                );
                return;
            }
            let saved = result.data.dataset;
            this.showDatasetDialog = false;
            await this.loadDatasets(true);
            let dataset = this.datasets.find((item: any) => item.id === saved.id) || saved;
            if (editing) {
                if (this.workspaceDataset && this.workspaceDataset.id === dataset.id) {
                    this.workspaceDataset = dataset;
                }
            } else {
                await this.openDataset(dataset);
            }
        } finally {
            this.datasetCreating = false;
            this.editingDataset = null;
            await this.service.render();
        }
    }

    public async load(quiet: boolean = false) {
        let dataset = this.currentDataset();
        if (!dataset.dataset_id) {
            this.runs = [];
            this.loadError = '';
            this.loading = false;
            await this.service.render();
            return;
        }
        if (!quiet) {
            this.loadError = '';
            this.loading = true;
            await this.service.render();
        }
        try {
            let result: any = await this.service.request.post('/api/generation/runs/list', {
                dataset_id: dataset.dataset_id
            });
            if (result.code !== 200) {
                if (!quiet) {
                    this.loadError = result.data && result.data.message
                        ? String(result.data.message)
                        : '잠시 후 다시 시도해 주세요.';
                }
                return;
            }
            this.loadError = '';
            this.runs = result.data.runs || [];
            this.inputSummary = result.data.input_summary || {
                text_unit_count: 0,
                source_document_count: 0,
                source_version_count: 0,
                source_groups: {}
            };
            this.profile = result.data.profile || {};
            this.runPage = Math.min(this.runPage, this.runPageCount());
        } catch (error) {
            if (!quiet) this.loadError = '서버 연결을 확인한 뒤 다시 시도해 주세요.';
        } finally {
            if (!quiet) this.loading = false;
            await this.service.render();
        }
    }

    private normalize(value: any) {
        return String(value || '').trim().toLocaleLowerCase();
    }

    public selectedProfile() {
        return this.profile || {};
    }

    public async openCreateDialog() {
        if (!this.currentDataset().dataset_id) {
            await this.showError('QA 데이터셋을 먼저 선택해 주세요.');
            return;
        }
        if (!this.eligibleUnitCount()) {
            await this.showError('QA 데이터셋에 생성 가능한 TextUnit이 없습니다.');
            return;
        }
        this.form = this.newForm();
        this.form.run_name = this.automaticRunName();
        this.showCreateDialog = true;
        await this.service.render();
    }

    public automaticRunName() {
        let datasetName = String(
            this.currentDataset().dataset_name
            || (this.workspaceDataset && this.workspaceDataset.name)
            || 'QA 데이터셋'
        ).trim();
        return (datasetName + ' · ' + formatKstDateTime(new Date(), '')).substring(0, 200);
    }

    public canSubmitCreateRun() {
        let target = Number(this.form.target_count || 0);
        let targetMax = Number(this.selectedProfile().target_max || 20);
        return !this.creating
            && this.eligibleUnitCount() > 0
            && target >= 1
            && target <= targetMax
            && target <= this.eligibleUnitCount();
    }

    private async registerGenerationRun(payload: any) {
        return await this.service.request.post(
            '/api/generation/runs/create',
            payload
        );
    }

    public async closeCreateDialog() {
        if (this.creating) return;
        this.showCreateDialog = false;
        await this.service.render();
    }

    public async createRun() {
        if (this.creating) return;
        if (!this.eligibleUnitCount()) {
            await this.showError('QA 데이터셋에 생성 가능한 TextUnit이 없습니다.');
            return;
        }
        if (!this.form.run_name || this.form.run_name.trim().length < 2) {
            this.form.run_name = this.automaticRunName();
        }
        let target = Number(this.form.target_count || 0);
        let selectedProfile = this.selectedProfile();
        let targetMax = Number(selectedProfile.target_max || 20);
        if (target < 1 || target > targetMax || target > this.eligibleUnitCount()) {
            await this.showError(
                '생성 수량은 데이터셋의 TextUnit 범위 안에서 1~' + targetMax + '건으로 지정해 주세요.'
            );
            return;
        }
        this.creating = true;
        await this.service.render();
        let registeredRun: any = null;
        let queueMessage = '';
        try {
            let result: any = await this.registerGenerationRun({
                dataset_id: this.currentDataset().dataset_id,
                run_name: this.form.run_name,
                target_count: target,
                idempotency_key: this.form.idempotency_key
            });
            if (result.code !== 201 && result.code !== 200) {
                await this.showError(
                    result.data && result.data.message
                        ? result.data.message
                        : 'QA 생성 실행을 등록하지 못했습니다.'
                );
                return;
            } else {
                registeredRun = result.data.run;
                queueMessage = result.data.queue_message || (
                    'QA 생성 작업이 대기열에 등록되었습니다. '
                    + '화면을 닫아도 백그라운드에서 계속 진행됩니다.'
                );
                this.showCreateDialog = false;
                this.form = this.newForm();
            }
        } catch (error) {
            await this.showError('작업 등록 중 연결이 끊겼습니다. 같은 생성 버튼을 다시 누르면 중복 없이 기존 작업을 확인합니다.');
        } finally {
            this.creating = false;
            await this.service.render();
        }
        if (!registeredRun) return;
        await this.showQueued(queueMessage);
        await this.load(false);
        let current = this.runs.find(
            (item: any) => item.id === registeredRun.id
        ) || registeredRun;
        await this.openDetail(current, false);
    }

    public filteredRuns() {
        let query = this.normalize(this.runQuery);
        return this.runs.filter((run: any) => {
            if (this.runStatusFilter !== 'ALL' && run.status !== this.runStatusFilter) return false;
            if (!query) return true;
            return this.normalize([
                run.run_name,
                run.status,
                run.current_stage,
                run.error_message,
                this.statusLabel(run.status),
                this.stageLabel(run.current_stage)
            ].join(' ')).indexOf(query) >= 0;
        });
    }

    public visibleRuns() {
        let start = (this.runPage - 1) * this.runPageSize;
        return this.filteredRuns().slice(start, start + this.runPageSize);
    }

    public runPageCount() {
        return Math.max(1, Math.ceil(this.filteredRuns().length / this.runPageSize));
    }

    public runPageStart() {
        return this.filteredRuns().length ? (this.runPage - 1) * this.runPageSize + 1 : 0;
    }

    public runPageEnd() {
        return Math.min(this.runPage * this.runPageSize, this.filteredRuns().length);
    }

    public updateRunFilter() {
        this.runPage = 1;
    }

    public setRunStatusFilter(value: string) {
        this.runStatusFilter = value;
        this.updateRunFilter();
    }

    public runStatusCount(value: string) {
        return this.runs.filter((run: any) => run.status === value).length;
    }

    public clearRunFilters() {
        this.runQuery = '';
        this.runStatusFilter = 'ALL';
        this.runPage = 1;
    }

    public clearRunSearch() {
        this.runQuery = '';
        this.runPage = 1;
    }

    public changeRunPage(direction: number) {
        this.runPage = Math.max(1, Math.min(this.runPageCount(), this.runPage + direction));
    }

    public async openDetail(run: any, quiet: boolean = false) {
        if (!quiet) {
            this.detailLoading = true;
            await this.service.render();
        }
        try {
            let result: any = await this.service.request.post('/api/generation/runs/detail', {
                dataset_id: this.currentDataset().dataset_id,
                run_id: run.id
            });
            if (result.code !== 200) {
                if (!quiet) {
                    await this.showError(
                        result.data && result.data.message
                            ? result.data.message
                            : 'QA 생성 상세를 불러오지 못했습니다.'
                    );
                }
                return;
            }
            this.selected = result.data.run;
            if (!quiet) this.syncGenerationUrl(run.id);
        } finally {
            if (!quiet) this.detailLoading = false;
            await this.service.render();
        }
    }

    public async closeDetail() {
        this.selected = null;
        this.syncGenerationUrl();
        await this.service.render();
    }

    public async retry(run: any) {
        let confirmed = await this.service.modal.show({
            title: '실패 지점부터 다시 시작',
            message: '완료된 단계는 유지하고 ' + this.stageLabel(run.current_stage) + ' 단계부터 다시 실행합니다.',
            cancel: '취소',
            action: '재시도',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;
        let result: any = await this.service.request.post('/api/generation/runs/retry', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: run.id
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message ? result.data.message : '재시도 요청에 실패했습니다.'
            );
            return;
        }
        this.selected = result.data.run;
        await this.load(true);
    }

    public async cancel(run: any) {
        let confirmed = await this.service.modal.show({
            title: '대기 중인 QA 생성 취소',
            message: run.run_name + ' 작업을 취소하시겠습니까?',
            cancel: '유지',
            action: '취소',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        let result: any = await this.service.request.post('/api/generation/runs/cancel', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: run.id
        });
        if (result.code !== 200) {
            await this.showError(
                result.data && result.data.message ? result.data.message : '실행 취소에 실패했습니다.'
            );
            return;
        }
        this.selected = result.data.run;
        await this.load(true);
    }

    public stageState(run: any, stage: string) {
        let metrics = run.metrics || {};
        let stages = metrics.stages || {};
        return (stages[stage] || {}).status || 'WAITING';
    }

    public stageStateLabel(value: string) {
        let labels: any = {
            WAITING: '대기', RUNNING: '진행 중', SUCCEEDED: '완료', FAILED: '실패', SKIPPED: '건너뜀'
        };
        return labels[value] || value;
    }

    public statusLabel(value: string) {
        let labels: any = {
            DRAFT: '설정 중', QUEUED: '대기', RUNNING: '진행 중',
            COMPLETED: '완료', FAILED: '실패', CANCELED: '취소됨'
        };
        return labels[value] || value;
    }

    public stageLabel(value: string) {
        let labels: any = {
            INDEXING: '입력 정리', KEYWORDING: '키워드 준비', GROUNDING: '원문 연결',
            EVIDENCE_SELECTING: '근거 선별', QA_GENERATING: '질문·답변 생성', VALIDATING: 'QA 평가',
            WRITING_OUTPUTS: '결과 저장'
        };
        return labels[value] || value || '작업 준비';
    }

    public runProfileMode(run: any) {
        return String(run.generator_backend || '').indexOf('skeleton') >= 0
            ? '연결 테스트'
            : '하네스 구조 QA 생성';
    }

    public runStatusMessage(run: any) {
        if (run.error_message) return run.error_message;
        if (run.status === 'QUEUED') return '작업 시작을 기다리고 있습니다.';
        if (run.status === 'COMPLETED') return 'QA 생성과 자동 검증이 완료되었습니다.';
        if (run.status === 'CANCELED') return '사용자가 대기 작업을 취소했습니다.';
        return this.stageLabel(run.current_stage) + ' 단계를 처리하고 있습니다.';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '-');
    }
}

export default PageAuthoringRunsComponent;